<template>
  <transition name="fade">
    <div v-if="doShow" :class="baseClass">
      <button
        v-if="abortable"
        class="absolute top-0 right-0 py-4 px-6 tracking-wider text-gray-500 hover:text-gray-900 uppercase focus:outline-none"
        @click="$emit('abort')"
      >abbrechen</button>
      <div class="flex justify-center items-center p-10 w-64 h-64 spinner">
        <img src="@/assets/logo.svg" class="w-full">
      </div>
      <p class="pt-8 text-xl text-gray-800" v-text="text" />
    </div>
  </transition>
</template>

<script>
  export default {
    name: 'LoadingIndicator',
    props: {
      mode: { type: String, default: 'overlay' },
      doShow: { type: Boolean, default: true },
      abortable: { type: Boolean, default: false },
      text: { type: String, default: 'Laden...' }
    },
    emits: ['abort'],
    computed: {
      baseClass () {
        switch (this.mode) {
          case 'overlay':
            return 'fixed inset-0 z-50 text-primary flex flex-col items-center justify-center bg-overlay'
          case 'flex-fill':
          default:
            return 'flex-grow flex flex-col justify-center items-center'
        }
      }
    }
  }
</script>

<style scoped>
  .spinner {
    position: relative;
  }

  .spinner:before {
    content: '';
    top: 0;
    left: 0;
    position: absolute;
    display: block;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    border-radius: 50%;
    border: 4px solid #ccc;
    border-top-color: #3D4852;
    animation: spinner 1s linear infinite;
  }

  @keyframes spinner {
    to { transform: rotate(360deg); }
  }

  .bg-overlay {
    background-color: rgba(255, 255, 255, 0.9);
  }
</style>
